import Vue from 'vue';
import App from './App.vue';

import router from './router';
import store from './store';

import config from './config.js'
import {SAAS} from './config.js'
import library from '@deanwu/vue-component-library'
import '@deanwu/vue-component-library/dist/vue-component-library.css'
Vue.use(library, config);

import {DatePicker} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(DatePicker);

import comps from './components/index.js'
Vue.use(comps);

// 挂载子项目组件
import subComps from '@/submodule/components';
Vue.use(subComps, {
	saas: SAAS,
	$message: opt => {
		app.$message({
			message: opt.text
		})
	},
	$confirm: opt => {
		app.$confirm({
			message: opt.text,
			resolve: opt.resolve
		})
	},
	$upload: opt => {
		app.$upload({
			type: opt.fileType,
			multiple: opt.multiple,
			loading: true,
			success: data => {
				opt.success(data.map(item => {
					return {
						fileObj: item.fileObj,
						fileName: item.fileObj.name,
						filePath: item.path
					}
				}))
			}
		});
	}
});

Vue.prototype.SAAS = SAAS;

Vue.prototype.$bus = new Vue();

Vue.prototype.oss = function(url, w, h) {
	if (!url) return '';
	return `${url}?x-oss-process=image/resize,h_${h * 2},w_${w * 2}/quality,q_80`;
};

// 上传文件
Vue.prototype.commonUploadFile = function(opt) {
	app.$upload(opt);
};

Vue.config.productionTip = false;

const app = window.$app = new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');
